import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Input  } from '@angular/core';
import { DataService } from '../../../services/data/data.service';
import { Subscription } from '../../../../../node_modules/rxjs';
import { BoxQuotaData } from '../../../model/box.quote.data';
import { getPipBySymbol } from '../../../interfaces/quote.data'; 

@Component({
    selector: 'cu-download-link-cell-pnl-renderer',
   // styles: [require('./tradeskOrdersTab/tradeskOrdersTab.component.css')],
    template: `<span [ngClass]="{'green-fa': PipValue>0, 'red-fa': PipValue<0}">{{PipValue}}</span>`
  })

  
  export class OrderPipsCellRenderer {
      params:any;
      constructor(  ) {
      }
      
      public direction:string="";
      agInit(params:any): void { 
          this.params = params;
          this.PipValue = this.params.data.Pips 
     }

     refresh(params: any): void {
      this.params = params;
//debugger;
    // console.log("refreshPips");
    // console.log(this.params.data);

      this.PipValue = this.params.data.Pips 
      
       }

     private _PipValue:number = 0;

     set PipValue(v:number)
     {
 //      debugger;
       this._PipValue = v;
     }
    get PipValue():number
    {
      return this._PipValue;
    }
  }
  
  export type CellAction = (params:any) => void;